export const isMenuItemActive = (pathname, path) => {
  if (!path) return false;

  const isVaultPath = path === "/vault";
  const isVaultDocumentOrPotential = pathname.startsWith("/vault/documents") || pathname.startsWith("/vault/potential");

  if (isVaultPath) {
    return pathname === "/vault" || (pathname.startsWith("/vault/") && !isVaultDocumentOrPotential);
  }

  const isArcPlcCountiesPath = path === "/arcplc";
  const isArcPlcPayments =
    pathname.startsWith("/arcplc/payments") || pathname.startsWith("/arcplc/farm-payments");

  if (isArcPlcCountiesPath) {
    return pathname === "/arcplc" || (pathname.startsWith("/arcplc/") && !isArcPlcPayments);
  }

  // Scenarios owns /insurance and /insurance/:id…, not the sibling leaf /claims
  if (path === "/insurance") {
    const isInsuranceSibling = pathname.startsWith("/insurance/claims");
    return pathname === "/insurance" || (pathname.startsWith("/insurance/") && !isInsuranceSibling);
  }

  return pathname === path || pathname.startsWith(`${path}/`);
};

export const isParentMenuItemActive = (pathname, item, globalState) => {
  const getPath = (path) => (typeof path === "function" ? path(globalState) : path);

  if (item.path && isMenuItemActive(pathname, getPath(item.path))) {
    return true;
  }

  return item.children?.some((child) => child.path && isMenuItemActive(pathname, getPath(child.path)));
};
